import React from "react";
import { useLocation } from "react-router-dom"; // 1. Import useLocation

import Header from "../Header/Header";
import Routers from "../../router/Routers";
import Footer from "../Footer/Footer";
import ChatButton from "../Chat/ChatButton";

const Layout = () => {
  const location = useLocation(); // 2. Lấy thông tin đường dẫn hiện tại

  // 3. Kiểm tra xem đường dẫn có bắt đầu bằng "/admin" không
  // Nếu bạn muốn ẩn ở cả trang login (ví dụ /login), bạn có thể thêm điều kiện vào đây
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {/* 4. Chỉ hiển thị Header nếu KHÔNG PHẢI trang admin */}
      {!isAdminRoute && <Header />}
      
      {/* Thẻ main này sẽ gánh nhiệm vụ đẩy Footer xuống đáy */}
      <main style={{ flex: '1 0 auto' }}>
        <Routers />
      </main>
      
      {/* 5. Tương tự với ChatButton và Footer */}
      {!isAdminRoute && <ChatButton />}
      {!isAdminRoute && <Footer />}
    </div>
  );
};

export default Layout;